import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        padding: '.15rem .3rem',
        backgroundColor: '#FFFFFF00',
        fontSize: '.8rem',
        textTransform: 'none' as 'none',
        border: '1px solid #FFFFFF00',
        borderRadius: '20px',
        '&:hover': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#F1F1F1',
            border: `1px solid ${theme?.app?.applicationColors.enumColors.white || '#F1F1F1'}`
        }
    },
    icon: {
        fontSize: '1rem',
        width: '20px',
        height: '20px'
    },
    active: {
        backgroundColor:
            theme?.app?.applicationColors.tableRowAlternatingHighlightColor || 'rgb(185, 217, 236)'
    }
}));